<template>
    <az-call-to-action dark
                       :active="licitacao.podeAcessar"
                       :outline="!licitacao.podeAcessar"
                       @click="acessarPregao(licitacao)">
        Acessar
    </az-call-to-action>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'LicitacaoEdicaoAcoesExecutar',
        computed: {
            ...mapState(['licitacao'])
        }
    }
</script>